import { Component } from '@angular/core';
import { AbstractI18nService, Language } from '@libs/index';
import { BaseComponent } from '@libs/index';
import { takeUntil } from 'rxjs/operators';
import { BreakpointService } from '@libs/index';
import { PwaService } from '@libs/index';

@Component({
  selector: 'app-static-content-download-app',
  templateUrl: './static-content-download-app.component.html',
  styleUrls: ['./static-content-download-app.component.scss'],
})
export class StaticContentDownloadAppComponent extends BaseComponent {
  public downloadOnAppleStoreBadge: string;
  public downloadOnGooglePlayBadge: string;

  constructor(
    public breakpointService: BreakpointService,
    private i18nService: AbstractI18nService,
    private pwaService: PwaService
  ) {
    super();

    this.i18nService.selectedLanguage$
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((l) => this.generateDownloadBadges(l));
  }

  public triggerDownloadPwa(): void {
    this.pwaService.installPwa();
  }

  private generateDownloadBadges(language: Language): void {
    this.downloadOnAppleStoreBadge = `assets/images/download-app-badges/app-store-badge-${language.countryCode}.svg`;
    this.downloadOnGooglePlayBadge = `assets/images/download-app-badges/google-play-badge-${language.countryCode}.png`;
  }
}
